import { combineReducers } from 'redux';

import router from './router';
import socket from './socket';
import orm from './orm';
import auth from './auth';
import core from './core';
import action from './action';
import reports from './reports';
import system from './system';
import realtimeDatas from './realtime-datas';
import invoices from './invoices';
import authenticateForm from './forms/authenticate';
import userCreateForm from './forms/user-create';
import factoryCreateForm from './forms/factory-create';
import modelCreateForm from './forms/model-create';
import protocolCreateForm from './forms/protocol-create';
import itemCreateForm from './forms/item-create';
import alertSettingCreateForm from './forms/alert-setting-create';
import settingPriceCreateForm from './forms/setting-price-create';
import settingEmailsCreateForm from './forms/setting-emails-create';
import channelCreateForm from './forms/channel-create';
import brandCreateForm from './forms/brand-create';
import deviceCreateForm from './forms/device-create';
import componentCreateForm from './forms/component-create';

export default combineReducers({
  router,
  socket,
  orm,
  auth,
  core,
  action,
  reports,
  system,
  invoices,
  realtimeDatas,
  authenticateForm,
  userCreateForm,
  factoryCreateForm,
  modelCreateForm,
  protocolCreateForm,
  itemCreateForm,
  alertSettingCreateForm,
  settingPriceCreateForm,
  settingEmailsCreateForm,
  channelCreateForm,
  brandCreateForm,
  deviceCreateForm,
  componentCreateForm,
});
